/** @format */

import APIRequest from "../utils/APIRequest";
import APIRequestONX from "../utils/APIRequestONX";
export default class MessageTemplate {
  static getAll = async ({
    waba_id,
    limit = 10,
    before = "",
    after = "",
    name = "",
  }) => {
    let query_params = "";
    if (before) {
      query_params += `&before=${before}`;
    }

    if (after) {
      query_params += `&after=${after}`;
    }

    if (name) {
      query_params += `&name=${name}`;
    }

    return await APIRequest.set(
      `v1/message_templates/${waba_id}&limit=${limit}${query_params}`,
      "GET"
    );
  };

  static getByID = async (waba_id, id) => {
    return await APIRequest.set(`v1/message_template/${waba_id}/${id}`, "GET");
  };

  static getDetailByID = async (id) => {
    return await APIRequest.set(`v1/message_template/detail/${id}`, "GET");
  };

  static create = async (body) => {
    return await APIRequest.set(`v1/message_template/create`, "POST", body);
  };

  static delete_ = async (name, waba_id) => {
    return await APIRequest.set(`v1/message_template`, "DELETE", {
      waba_id,
      name: name,
    });
  };

  static getCategory = async () => {
    return await APIRequest.set(`v1/message_template/category`, "GET");
  };

  static createBroadcast = async (body) => {
    return await APIRequest.set("v1/broadcast", "POST", body);
  };

  static sendBroadcast = async (body) => {
    return await APIRequest.set("v1/broadcast-worker", "POST", body);
  };

  static getLanguage = async () => {
    return await APIRequest.set(`v1/message_template/language`, "GET");
  };

  static getTemplate = async (waba_id, id) => {
    return await APIRequest.setFileDownload(
      `v1/message_template/get-template/${waba_id}/${id}`,
      "GET"
    );
  };

  static postImage = async (file) => {
    return await APIRequestONX.setMultipart("minio/upload", "POST", file);
  };

  static postFileTemplateWA = async (body) => {
    return await APIRequest.set("v1/waba-media-template/upload", "POST", body);
  };

  static postFileBroadcastWA = async (body) => {
    return await APIRequest.set("v1/waba-media/upload", "POST", body);
  };
}
